import { useSelector } from 'react-redux';

import { IProductProps } from 'store/modules/product';

import { IState } from 'store';
import { IUserProps } from 'store/modules/profile';

import SOComponentItem from './SOComponentItem';

import * as S from './styles';

interface SOComponent {
  product: IProductProps;
}

export default function SOComponent({ product }: SOComponent) {
  const user = useSelector<IState, IUserProps>(state => state.profile.user);

  return (
    <S.Container className="so-component">
      {product?.farmacia?.medicamento ? (
        <SOComponentItem
          // message="Acumule descontos nas suas compras"
          activeClub={user.clubeAtivo}
        />
      ) : (
        <>
          {product?.bonificacaoClube > 0 ? (
            <SOComponentItem
              // message={`Na compra deste produto você acumula <b class="price">R$ ${formatCurrency(
              //   product.creditoBonificacaoClube,
              // )}</b> em cashback.`}
              activeClub={user.clubeAtivo}
            />
          ) : (
            <SOComponentItem
              // message="Acumule descontos nas suas compras"
              activeClub={user.clubeAtivo}
            />
          )}
        </>
      )}
    </S.Container>
  );
}
